import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable, { MTableToolbar } from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Chip from '@material-ui/core/Chip';

export default class ContactDataTable extends React.Component {
  constructor(props) {
    super(props);
    // console.log(this.props.tags);
    this.tableRef = React.createRef();
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });
    this.state = {
      columns: [
        // { title: 'ID', field: 'id', editable: 'never' },
        { title: 'Name', field: 'name', grouping: false },
        { title: 'Email', field: 'email',grouping: false },
        { title: 'Phone Number', field: 'phone_number', grouping: false },
        { title: 'Contactable', field: 'contactable_type', editable: 'never' },
        { 
          title: 'Tags', 
          field: 'tag_list',
          width: 350,
          render: rowData => this.label(rowData),
          addPlaceholder: 'Use comma for multiple tags',
          placeholder: 'Use comma for multiple tags',
          tooltip: 'Use comma for multiple tags',
          resizable: true,
          // lookup: this.props.tags
        },
        // { title: 'Created at', field: 'created_at', editable: 'never', width: 250 },
      ],
      data: [],
      page: null,
      open: false,
      totalCount: null
    }
  }

  label(rowData){
    if (rowData.tag_list && rowData.tag_list.length) {
      // console.log(rowData.tag_list);
      return(
        <div>
          {rowData.tag_list.map((tag, index) => (
            <Chip size="small" className="mr-2 mb-2" key={index} label={tag} />
          ))}
        </div>
      )
    }
  }

  fetchData(query){
    return new Promise((resolve, reject) => {
      let url = '/api/contacts?'
      // console.log('params', query)
      url += 'per_page=' + query.pageSize
      url += '&q=' + query.search
      url += '&page=' + (query.page + 1)
      fetch(url)
        .then(res => (res && res.status === 200 && res.ok ? res.json() : Promise.reject(res)))
        .then(data => {
          resolve({
            data: data.contacts,
            page: data.pagination.page - 1,
            totalCount: data.pagination.count
          })
        })
    })
  }

  batchDelete(contacts){
    
    var array_keys = new Array();
    const insuranceIds = contacts.map((insurance) => array_keys.push(insurance.id));
    console.log('array_keys', array_keys);
    const csrfToken = document.querySelector('[name=csrf-token]').content
    new Promise((resolve, reject) => {
      return fetch('/api/contacts/batch_delete', {
        method: 'POST',
        body: JSON.stringify({
          insurance_ids: array_keys
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          'X-CSRF-Token': csrfToken
        }
      }).then(response => {
        return response.json()
      }).then(result => {
        console.log(result);
        <Snackbar
          autoHideDuration={6000}
          open
          message={result.message}
        />
        this.tableRef.current && this.tableRef.current.onQueryChange()
        // const data = this.state.data;
        // data.push(newData);
        // this.setState({ data }, () => resolve());
      })
      resolve()
      
    })
  }

  handleClick(tag){
    console.info('You clicked the Chip.', tag);
  };

  render() {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title="contacts"
          columns={this.state.columns}
          tableRef={this.tableRef}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            },
            // {
            //   tooltip: 'Remove All Selected Users',
            //   icon: 'delete',
            //   onClick: (evt, data) => this.batchDelete(data) && this.setState({open: true})
            // }
          ]}
          options={{
            pageSize: 50,
            pageSizeOptions: [50, 100, 200, 500, 1000],
            exportButton: true,
            sorting: true,
            search: true,
            addRowPosition: 'first',
            grouping: true
            // filtering: true
          }}
          onRowClick={(event, rowData) => rowData.contactable_url ? Turbolinks.visit(rowData.contactable_url) : null}
          data={query =>
            this.fetchData(query)
          
          }
          // components={{
          //   Toolbar: props => (
          //     <div>
          //       <MTableToolbar {...props} />
          //       <div className="mb-2 pl-3">
          //         {this.props.tags.map((tag, index) => (
          //           <Chip size="small" className="m-2" key={index} onClick={this.handleClick.bind(this, tag)} label={tag} />
          //         ))}
          //       </div>
          //     </div>
          //   ),
          // }}
          editable={{
            onRowAdd: newData =>
              new Promise((resolve, reject) => {
                const csrfToken = document.querySelector('[name=csrf-token]').content
                setTimeout(() => {
                  {
                    return fetch('/api/contacts/', {
                      method: 'POST',
                      body: JSON.stringify(newData),
                      headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'X-CSRF-Token': csrfToken
                      }
                    }).then(response => {
                      return response.json()
                    }).then(result => {
                      console.log(result)
                      const data = this.state.data;
                      data.push(newData);
                      this.setState({ data }, () => resolve());
                    })
                    
                  }
                  resolve()
                }, 350)
              }),
            onRowUpdate: (newData, oldData) =>

              new Promise((resolve, reject) => {
                const csrfToken = document.querySelector('[name=csrf-token]').content
                // console.log('token is', csrfToken);
                setTimeout(() => {
                  {
                    return fetch(`/api/contacts/${newData.id}`, {
                      method: 'PUT',
                      body: JSON.stringify(newData),
                      headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'X-CSRF-Token': csrfToken
                      }
                    }).then(response => {
                      return response.json()
                    }).then(result => {
                      console.log(result)
                      const data = this.state.data;
                      const index = data.indexOf(oldData);
                      data[index] = newData;
                      this.setState({ data }, () => resolve());
                    })
                      
                  }
                  resolve()
                }, 350)
              }),
            onRowDelete: oldData =>
              new Promise((resolve, reject) => {
                const csrfToken = document.querySelector('[name=csrf-token]').content
                setTimeout(() => {
                  {
                    return fetch(`/api/contacts/${oldData.id}`, {
                      method: 'DELETE',
                      headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'X-CSRF-Token': csrfToken
                      }
                    }).then(response => {
                      return response.json()
                    }).then(result => {
                      console.log(result)
                      let data = this.state.data;
                      const index = data.indexOf(oldData);
                      data.splice(index, 1);
                      this.setState({ data }, () => resolve());
                    })

                  }
                  resolve()
                }, 350)
              }),
          }}
        />
      </MuiThemeProvider>
    )
  }

}

